<template>
  <v-card flat class="product-view">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pt-0 pb-1">
      <v-row>
        <v-col cols="6" class="pb-0 pt-0">{{ orderModel.number }}</v-col>
        <v-col cols="6" class="pb-0 pt-0 text-right">{{ $t('message.order.delivery') }}: {{ orderModel.orderdate | dateFormat }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0 pl-3">{{ orderModel.warehouse_name || '' }}</v-col>
        <v-col cols="12" class="pa-0 pl-3">{{ orderModel.warehouse_name_1 || '' }}</v-col>
      </v-row>
    </v-card-text>
    <v-card-text class="highlight pt-0 pb-0 pl-1">
      <v-row>
        <v-col cols="6" class="pa-0 pl-3 font-weight-bold">{{ $t('message.order.products') }}:</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.ordered') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.order.received') }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right font-weight-bold">{{ $t('message.ccsheet.unit') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in listOfProducts" :key="index">
        <v-col cols="6" class="pa-0 pl-3" :class="{ 'pb-1': (index === listOfProducts.length - 1)}">
          <v-row>
            <v-col cols="6" class="pa-0 pl-3 text-truncate">{{ product.productnumber }}</v-col>
            <v-col cols="6" class="pa-0 text-truncate" :title="product.productname">{{ product.productname }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right">{{ product.orderedqty }}</v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right">
          {{ product.receivedqty }}
        </v-col>
        <v-col cols="2" class="pa-0 pl-3 text-right">
          <span class="caption">{{ product.unitname }}</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="pickOrderHandler('collect')" v-if="canCollect">{{ $t('message.order.collect') }}</v-btn>
      <v-btn color="primary" @click="pickOrderHandler('receive')" v-if="canReceive">{{ $t('message.order.receive') }}</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      orderId: 0,
      listOfProducts: [],
      orderModel: {},
      canCollect: false,
      canReceive: false
    }
  },
  mounted () {
    this.loading = true
    this.orderId = this.$route.params.order_id
    this.getOrderProducts()
    this.getOrderInfo()
  },
  methods: {
    getOrderInfo () {
      let model = {
        'expand': [{
          'select': ['name'],
          'model': 'Warehouse',
          'on_field': 'id',
          'on_parent_field': 'warehouseid'
        }, {
          'select': ['name'],
          'model': 'Warehouse',
          'on_field': 'id',
          'on_parent_field': 'destinationwarehouseid'
        }],
        'filter': `id eq '${this.orderId}'`
      }
      this.$api.execute('post', 'warehouseorders/query', model)
        .then((response) => {
          if (response.data) {
            this.orderModel = response.data[0]
          }
        })
    },
    getOrderProducts () {
      this.$api.execute('get', `warehouseorders/get_products_by_order/${this.orderId}`)
        .then((response) => {
          if (response.data) {
            let list = response.data
            let canReceive = list.find(x => x.pickedqty > 0 && x.pickedqty !== x.receivedqty)
            if (canReceive) this.canReceive = true
            let canCollect = list.find(x => +x.orderedqty > x.pickedqty && x.pickedqty >= x.receivedqty)
            if (canCollect) this.canCollect = true
            list.map((x) => {
              x.receivedqty = this.$format.absoluteNumber(x.receivedqty)
              x.orderedqty = this.$format.absoluteNumber(x.orderedqty)
              return x
            })
            this.listOfProducts = list
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    pickOrderHandler (type) {
      this.$router.push(`/transfer_orders/${this.orderId}/transfer/${type}`)
    }
  }
}
</script>
